<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      :class="{
        'login-signin-on': this.state == 'signin',
        'login-forgot-on': this.state == 'forgot'
      }"
      id="kt_login"
    >
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <!-- Elementos decorativos — dão dinamicidade usando a cor da marca -->
        <div class="login-blob login-blob--top"></div>
        <div class="login-blob login-blob--bottom"></div>
        <div class="login-dots"></div>
        <div class="login-ring"></div>

        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <div class="login-card">
              <form
                class="form"
                novalidate="novalidate"
                id="kt_login_signin_form"
              >
                <div class="login-card-header">
                  <h3 class="login-title">Olá! Vamos nos conectar? :)</h3>
                  <p class="login-subtitle">Acesse sua conta para continuar</p>
                </div>

                <div class="form-group modern-field">
                  <label class="modern-label">E-mail</label>
                  <div class="input-icon-group">
                    <i class="fas fa-envelope input-icon"></i>
                    <input
                      class="form-control modern-input"
                      type="text"
                      name="email"
                      ref="email"
                      placeholder="seu@email.com"
                      v-model="form.email"
                    />
                  </div>
                </div>

                <div class="form-group modern-field">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <label class="modern-label mb-0">Senha</label>
                    <a
                      class="forgot-link"
                      id="kt_login_forgot"
                      @click="showForm('forgot')"
                      >Esqueceu sua senha?</a
                    >
                  </div>
                  <div class="input-icon-group mt-2">
                    <i class="fas fa-lock input-icon"></i>
                    <input
                      class="form-control modern-input"
                      type="password"
                      name="senha"
                      ref="senha"
                      placeholder="Sua senha"
                      v-model="form.senha"
                      autocomplete="off"
                    />
                  </div>
                </div>

                <div class="pt-2 pb-4">
                  <button
                    ref="kt_login_signin_submit"
                    class="btn btn-primary modern-btn-primary font-weight-bolder w-100"
                  >
                    Entrar
                  </button>
                </div>

                <!-- Login Integrado (SSO) — WEL-5239 -->
                <div class="modern-divider">
                  <span>ou continue com</span>
                </div>

                <!-- Botões Google / Microsoft -->
                <div class="d-flex justify-content-center modern-social-row">
                  <button
                    type="button"
                    class="modern-social-btn"
                    title="Continuar com Google"
                    @click="loginGoogle"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 48 48"
                      aria-hidden="true"
                    >
                      <path
                        fill="#FFC107"
                        d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                      />
                      <path
                        fill="#FF3D00"
                        d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                      />
                      <path
                        fill="#4CAF50"
                        d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                      />
                      <path
                        fill="#1976D2"
                        d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                      />
                    </svg>
                  </button>
                  <button
                    type="button"
                    class="modern-social-btn"
                    title="Continuar com Microsoft"
                    @click="loginMicrosoft"
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 21 21"
                      aria-hidden="true"
                    >
                      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                    </svg>
                  </button>
                </div>

                <!-- Login Corporativo (SAML/OIDC) -->
                <div class="modern-corporate-box">
                  <div class="modern-corporate-label">
                    <i class="fas fa-building"></i>
                    <span>Login Corporativo</span>
                  </div>
                  <div class="input-group modern-corporate-input-group">
                    <input
                      class="form-control modern-input modern-input--flat"
                      type="email"
                      placeholder="seu.email@empresa.com.br"
                      v-model="ssoEmail"
                      @keyup.enter="loginCorporativo"
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn modern-btn-outline"
                        @click="loginCorporativo"
                        :disabled="ssoLoading"
                      >
                        <span v-if="!ssoLoading">Continuar</span>
                        <span
                          v-else
                          class="spinner spinner-sm spinner-primary"
                        ></span>
                      </button>
                    </div>
                  </div>
                </div>

                <p class="recaptcha-disclaimer">
                  Este site é protegido pelo reCAPTCHA. A
                  <a href="https://policies.google.com/privacy"
                    >Política de Privacidade</a
                  >
                  e os
                  <a href="https://policies.google.com/terms"
                    >Termos de Serviço</a
                  >
                  do Google se aplicam.
                </p>
              </form>
            </div>
          </div>
          <!--end::Signin-->
          <!--begin::Forgot-->
          <div class="login-form login-forgot">
            <div class="login-card">
              <!--begin::Form-->
              <form
                class="form"
                novalidate="novalidate"
                id="kt_login_forgot_form"
                ref="kt_login_forgot_form"
              >
                <div class="login-card-header">
                  <h3 class="login-title">Recuperação de senha</h3>
                  <p class="login-subtitle">
                    Informe seu email para recuperar sua senha
                  </p>
                </div>

                <div class="form-group modern-field">
                  <label class="modern-label">E-mail</label>
                  <div class="input-icon-group">
                    <i class="fas fa-envelope input-icon"></i>
                    <input
                      class="form-control modern-input"
                      type="email"
                      placeholder="seu@email.com"
                      name="email"
                      v-model="formResetPassword.email"
                      autocomplete="off"
                    />
                  </div>
                </div>

                <div class="form-group d-flex pb-lg-0">
                  <button
                    type="submit"
                    id="kt_login_forgot_submit"
                    ref="kt_login_forgot_submit"
                    class="btn modern-btn-primary font-weight-bolder w-100 mr-3"
                  >
                    Enviar
                  </button>
                  <button
                    type="button"
                    id="kt_login_forgot_cancel"
                    class="btn modern-btn-cancel font-weight-bolder w-100"
                    @click="showForm('signin')"
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!--end::Forgot-->
        </div>
      </div>
      <!--end::Content-->
      <!--begin::Aside-->
      <div
        class="login-aside diagonal-aside d-flex flex-column flex-row-auto justify-content-center"
        style="background-color: #ff7900"
      >
        <a href="#" class="text-center mb-10">
          <img src="/media/comunicante/logo-wellon-login.png" alt="" />
        </a>
        <!-- <h3
            class="font-weight-bolder text-center font-size-h4 font-size-h1-lg"
            style="color: #356a7c"
          >
            Soluções inteligentes para atendimento e relacionamento com o
            cliente!
          </h3> -->
        <!-- <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
          :style="{ backgroundImage: `url(${backgroundImage})` }"
        ></div> -->
      </div>
      <!--begin::Aside-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters } from "vuex";
import {
  LOGIN,
  LOGOUT,
  RESET_PASSWORD
} from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

export default {
  name: "login-1",
  data() {
    return {
      state: "signin",
      form: {
        email: "",
        senha: "",
        token: ""
      },

      formResetPassword: {
        email: ""
      },
      ssoEmail: "",
      ssoLoading: false,
      windowWidth: 0
    };
  },
  computed: {
    ...mapGetters(["validatorErrors"]),

    backgroundImage() {
      return process.env.BASE_URL + "media/comunicante/bg-login.svg";
    }
  },
  mounted() {
    this.windowWidth = window.innerWidth;
    const signin_form = KTUtil.getById("kt_login_signin_form");
    const forgot_form = KTUtil.getById("kt_login_forgot_form");
    this.limparCacheFiltrosCampanha();

    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Campo obrigatório."
            },
            emailAddress: {
              message: "Informe um email válido."
            },
            blank: {}
          }
        },
        senha: {
          validators: {
            notEmpty: {
              message: "Campo obrigatório."
            },
            blank: {}
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv1 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "Campo obrigatório."
            },
            emailAddress: {
              message: "Informe um email válido."
            },
            blank: {}
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv.on("core.form.valid", async () => {
      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      await this.$recaptchaLoaded();
      this.form.token = await this.$recaptcha("login");

      this.$store
        .dispatch(LOGIN, this.form)
        .then(() => {
          this.$router.push(this.destinoAposLogin());
        })
        .catch(() => {
          for (const error in this.validatorErrors) {
            this.fv
              .updateValidatorOption(
                error,
                "blank",
                "message",
                this.validatorErrors[error]
              )
              .updateFieldStatus(error, "Invalid", "blank");
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    });

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: "Verifique suas credenciais!",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false
      });
    });

    this.fv1.on("core.form.valid", () => {
      const submitButton = this.$refs["kt_login_forgot_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      this.$store
        .dispatch(RESET_PASSWORD, this.formResetPassword)
        .then(() => {
          this.state = "signin";
          this.form = {
            email: "",
            senha: ""
          };
          this.formResetPassword = {
            email: ""
          };

          Swal.fire({
            title: "MENSAGEM: ",
            text: "Um link para recuperação de senha foi enviado para você, verifique seu email!",
            icon: "success",
            confirmButtonClass: "btn btn-success",
            heightAuto: false
          });
        })
        .catch(() => {
          for (const error in this.validatorErrors) {
            this.fv
              .updateValidatorOption(
                error,
                "blank",
                "message",
                this.validatorErrors[error]
              )
              .updateFieldStatus(error, "Invalid", "blank");
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    });
  },
  methods: {
    /**
     * Destino após o login. Normalmente a home; mas quando o usuário chegou
     * aqui a partir de um fluxo que precisa voltar (ponte de login do MCP,
     * WEL-5286), devolvemos para onde ele estava indo — senão os parâmetros
     * da autorização se perdem e a conexão falha.
     */
    destinoAposLogin() {
      const retorno = sessionStorage.getItem("retornoAposLogin");
      sessionStorage.removeItem("retornoAposLogin");

      // Só caminho interno: nunca redirecionar para host externo com base em
      // algo guardado no navegador.
      const interno =
        retorno && retorno.startsWith("/") && !retorno.startsWith("//");

      return interno ? retorno : "/";
    },
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },
    limparCacheFiltrosCampanha() {
      // Clear from localStorage (filtrosCampanha)
      localStorage.removeItem("filtrosCampanha");
    },
    loginGoogle() {
      const api = process.env.VUE_APP_COMUNICANTE_API;
      const baseUrl = api || window.location.origin;
      window.location.href = baseUrl + "/sso/google/login";
    },
    loginMicrosoft() {
      const api = process.env.VUE_APP_COMUNICANTE_API;
      const baseUrl = api || window.location.origin;
      window.location.href = baseUrl + "/sso/microsoft/login";
    },
    loginCorporativo() {
      const email = this.ssoEmail.trim();
      if (!email) {
        Swal.fire({
          title: "",
          text: "Digite seu email corporativo.",
          icon: "warning",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false
        });
        return;
      }

      if (!email.includes("@")) {
        Swal.fire({
          title: "",
          text: "Informe um email válido.",
          icon: "warning",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false
        });
        return;
      }

      this.ssoLoading = true;
      const api = process.env.VUE_APP_COMUNICANTE_API;
      const baseUrl = api || window.location.origin;

      fetch(baseUrl + "/sso/resolver?email=" + encodeURIComponent(email))
        .then((r) => r.json())
        .then((resp) => {
          if (resp.data && resp.data.encontrado) {
            window.location.href = resp.data.redirect;
          } else {
            const msg =
              resp.data?.mensagem ||
              "Login Integrado indisponível para este domínio.";
            Swal.fire({
              title: "",
              text: msg,
              icon: "info",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "",
            text: "Erro ao buscar Login Integrado. Tente novamente.",
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
            heightAuto: false
          });
        })
        .finally(() => {
          this.ssoLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.diagonal-aside {
  margin-top: -25em;
  margin-left: -5em;
  background: #ffffff;
  overflow: hidden;
  -webkit-transform: skew(-16deg) translateX(-70px);
  -ms-transform: skew(-16deg) translateX(-70px);
  transform: skew(16deg) translateX(100px);
  left: 0;
}

.diagonal-aside img {
  width: auto;
  max-width: 75%;
  max-height: 85vh;
  margin-left: -20em;
  margin-top: 28em;
  -webkit-transform: skew(16deg) translateX(140px);
  -ms-transform: skew(16deg) translateX(140px);
  transform: skew(-16deg) translateX(40px);
  left: 0;
  object-fit: contain;
}

@media screen and (max-width: 768px) {
  .diagonal-aside {
    display: none;
  }
}

/* ── Login moderno — WEL-5239 ── */

.login-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 2.75rem 2.5rem;
  box-shadow: 0 10px 40px rgba(72, 33, 130, 0.08),
    0 2px 8px rgba(72, 33, 130, 0.06);
  max-width: 440px;
  width: 100%;
}

.login-card-header {
  margin-bottom: 1.75rem;
}

.login-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #482182;
  margin-bottom: 0.35rem;
}

.login-subtitle {
  color: #9a9ab0;
  font-size: 0.95rem;
  font-weight: 400;
  margin-bottom: 0;
}

.modern-field {
  margin-bottom: 1.25rem;
}

.modern-label {
  color: #6b6b80;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 0.5rem;
  display: block;
}

.input-icon-group {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  color: #b3b3c6;
  font-size: 0.95rem;
  pointer-events: none;
  transition: color 0.2s ease;
}

.modern-input {
  height: 50px !important;
  padding: 0 16px 0 44px !important;
  border: 1.5px solid #e4e4ef !important;
  border-radius: 12px !important;
  background-color: #f9f9fc !important;
  font-size: 0.95rem;
  transition: border-color 0.2s ease, background-color 0.2s ease,
    box-shadow 0.2s ease;
}

.modern-input:focus {
  border-color: #482182 !important;
  background-color: #ffffff !important;
  box-shadow: 0 0 0 4px rgba(72, 33, 130, 0.08) !important;
  outline: none;
}

.input-icon-group:focus-within .input-icon {
  color: #482182;
}

.forgot-link {
  font-size: 0.85rem;
  font-weight: 600;
  color: #482182;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.forgot-link:hover {
  opacity: 0.75;
  text-decoration: underline;
}

.modern-btn-primary {
  height: 50px;
  background-color: #482182;
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-size: 1rem;
  box-shadow: 0 4px 14px rgba(72, 33, 130, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease;
}

.modern-btn-primary:hover,
.modern-btn-primary:focus,
.modern-btn-primary:active {
  color: #ffffff;
}

.modern-btn-primary:hover {
  background-color: #3a1a6a;
  box-shadow: 0 6px 18px rgba(72, 33, 130, 0.32);
  transform: translateY(-1px);
}

.modern-btn-primary:active {
  transform: translateY(0);
}

.modern-btn-cancel {
  height: 50px;
  border: 1.5px solid #e4e4ef;
  border-radius: 12px;
  color: #482182;
  background-color: #ffffff;
  font-size: 1rem;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.modern-btn-cancel:hover {
  background-color: #f9f9fc;
  border-color: #d8d8ea;
}

.modern-divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #b3b3c6;
  font-size: 0.82rem;
  font-weight: 600;
  margin: 1.5rem 0 1.25rem;
}

.modern-divider::before,
.modern-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #ececf5;
}

.modern-divider span {
  padding: 0 0.9rem;
  white-space: nowrap;
}

.modern-social-row {
  gap: 0.75rem;
  margin-bottom: 1.75rem;
}

.modern-social-btn {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1.5px solid #ececf5;
  background-color: #ffffff;
  font-size: 1.15rem;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    border-color 0.15s ease;
}

.modern-social-btn:hover {
  border-color: #d8d8ea;
  box-shadow: 0 4px 12px rgba(72, 33, 130, 0.12);
  transform: translateY(-2px);
}

.modern-corporate-box {
  background-color: #f9f9fc;
  border: 1px solid #ececf5;
  border-radius: 14px;
  padding: 1.1rem 1.15rem;
  margin-bottom: 1.5rem;
}

.modern-corporate-label {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  color: #6b6b80;
  font-size: 0.82rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  margin-bottom: 0.75rem;
}

.modern-corporate-label i {
  color: #ff7900;
}

.modern-corporate-input-group {
  height: 46px;
}

.modern-input--flat {
  height: 46px !important;
  padding: 0 14px !important;
  border: 1.5px solid #e4e4ef !important;
  border-radius: 10px 0 0 10px !important;
  background-color: #ffffff !important;
  font-size: 0.9rem;
}

.modern-btn-outline {
  height: 46px;
  padding: 0 1.1rem;
  border: 1.5px solid #e4e4ef;
  border-left: 2px solid #ffffff;
  border-radius: 0 10px 10px 0;
  color: #482182;
  font-weight: 600;
  font-size: 0.9rem;
  background-color: #f3f3f8;
  position: relative;
  z-index: 1;
  transition: background-color 0.15s ease;
}

.modern-btn-outline:hover {
  background-color: #ececf5;
}

.recaptcha-disclaimer {
  color: #b3b3c6;
  font-size: 0.75rem;
  line-height: 1.5;
  margin-bottom: 0;
}

.recaptcha-disclaimer a {
  color: #6b6b80;
  text-decoration: underline;
}

@media screen and (max-width: 576px) {
  .login-card {
    padding: 2rem 1.5rem;
    box-shadow: none;
  }
}

/* ── Elementos decorativos (cor da marca em tom translúcido) ── */

.login-content {
  max-width: 100% !important;
}

.login-card {
  position: relative;
  z-index: 1;
}

.login-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

.login-blob--top {
  top: -90px;
  left: -110px;
  width: 280px;
  height: 280px;
  background: radial-gradient(
    circle,
    rgba(72, 33, 130, 0.16) 0%,
    rgba(72, 33, 130, 0) 70%
  );
}

.login-blob--bottom {
  bottom: -140px;
  left: 18%;
  width: 340px;
  height: 340px;
  background: radial-gradient(
    circle,
    rgba(72, 33, 130, 0.12) 0%,
    rgba(72, 33, 130, 0) 70%
  );
}

.login-dots {
  position: absolute;
  top: 32px;
  left: 32px;
  width: 88px;
  height: 88px;
  background-image: radial-gradient(
    rgba(72, 33, 130, 0.28) 1.5px,
    transparent 1.5px
  );
  background-size: 16px 16px;
  pointer-events: none;
  z-index: 0;
}

.login-ring {
  position: absolute;
  bottom: 48px;
  left: 6%;
  width: 36px;
  height: 36px;
  border: 6px solid rgba(72, 33, 130, 0.14);
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

@media screen and (max-width: 576px) {
  .login-blob,
  .login-dots,
  .login-ring {
    display: none;
  }
}
</style>
